import { Component, OnInit, Inject } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ErrorComponent } from '@angular/synthrone-design/components';

@Component({
  selector: 'app-add-update-font-form',
  templateUrl: './add-update-font-form.component.html',
  styleUrls: ['./add-update-font-form.component.scss']
})
export class AddUpdateFontFormComponent implements OnInit {
 
  public newName: string;
  public submitClicked: boolean;
  public isEdit: boolean = false;
  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<AddUpdateFontFormComponent>,
      public dialog: MatDialog
  ) {
    this.submitClicked = false;
    this.newName = <string>this.data.oldName;
  }

  ngOnInit() {
    if (this.data.dataId) {
      this.isEdit = true;
    }
  }

  closeWindow = (param = null) => {
      this.dialogRef.close(param);
  };

  canSubmit = () => {
      return !(this.newName === this.data.oldName || this.newName.length < 3 || !this.newName.match(/^[A-z]+/));
  };

  submitFn = () => {
    this.submitClicked = true;
    this.data.callback(this.newName).catch((error: any) => {
        this.submitClicked = false;
        this.showError(error);
        return Observable.throw(error)
    }
    ).subscribe((response) => {
        this.closeWindow(true);
    });
  };

  inputKeyUp = (event) => {
      if (event.key === 'Enter' && this.canSubmit()) {
          this.submitFn();
      }
  };

  showError(message: string) {
    let dialogRef = this.dialog.open(ErrorComponent, {
        data: {
            message: message
        }
    });
    return dialogRef.afterClosed();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/add-update-font-form/add-update-font-form.component.ts